import { render } from "./RTableColumn.vue?vue&type=template&id=6a34ab96"
import script from "./RTableColumn.vue?vue&type=script&lang=js"
export * from "./RTableColumn.vue?vue&type=script&lang=js"

import exportComponent from "/home/jenkins/agent/workspace/yf-sassmc4ct_wyf-saas-web_master/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__